import React from 'react';
import { usePhases } from '../contexts/PhaseContext';
import { PhaseType } from '../data/mock';
import Button from './Inputs/Button';
import { useNavigate } from 'react-router-dom';

interface PhaseGateProps {
  phaseType: PhaseType;
  children: React.ReactNode;
}

const PhaseGate: React.FC<PhaseGateProps> = ({ phaseType, children }) => {
  const { phases, isPhaseUnlocked } = usePhases();
  const navigate = useNavigate();
  const phase = phases.find(p => p.type === phaseType);

  if (!phase || !isPhaseUnlocked(phase.id)) {
    return (
      <div className="section-gap items-center text-center py-20">
        <div className="w-16 h-16 rounded-full bg-surface flex items-center justify-center mx-auto mb-4">
          <svg className="w-8 h-8 text-muted" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0110 0v4" />
          </svg>
        </div>
        <h2 className="heading text-xl mb-2">Phase Locked</h2>
        <p className="text-muted text-sm max-w-md mx-auto mb-6">
          You need to complete the previous phases before accessing this section. Keep progressing through your journey to unlock it.
        </p>
        <Button variant="primary" size="sm" onClick={() => navigate('/app/journey')}>
          View My Journey
        </Button>
      </div>
    );
  }

  return <>{children}</>;
};

export default PhaseGate;
